import { set } from '@/plugins/vuex'

export default {
  roomData: set('room'),
  roomIdData: set('roomID'),
  
  setSchichtData (state, payload) {
    state.schichtOptions = payload
  },
}
